import { initTracking, setTrackingUser } from '@platform/tracking';
import { createSourcepointProvider } from '@platform/tracking/sourcepoint';
import { authBootstrap } from '../../config/authBootstrap';
import { env } from '../../config/runtime';
import '../../domains/_discover-tracking';
import { hubDataLayerAdapter } from '../../tracking/dataLayerAdapter';

export function bootstrapTracking() {
  // Before initTracking creates the GTM script tag, so the Sourcepoint chain sees the right user on
  // first paint. The handle is server-rendered; AuthProvider keeps it current from the session probe.
  setTrackingUser(authBootstrap.userHandle);

  initTracking({
    release: env.appVersion,
    environment: env.runtimeEnvironment,
    platform: 'hub',
    debug: env.runtimeEnvironment !== 'prod',
    gtmContainerId: env.gtmContainerId,
    // Same-origin relative POST to /collect: prod → BFF serves it; local → vite proxy.
    gatewayUrl: '',
    // GTM uses app_context to gate third-party tags (TikTok / Meta / …) that should only fire in the funnel.
    gtmDataLayer: { app_context: 'hub' },
    // Local dev: skip Sourcepoint CMP, treat all events as consented so tracking works without the consent banner
    consentProvider:
      env.runtimeEnvironment === 'local'
        ? { getConsent: () => true }
        : createSourcepointProvider({ privacyManagerId: env.privacyManagerId }),
    dataLayerAdapter: hubDataLayerAdapter,
    // biome-ignore lint/suspicious/noConsole: placeholder until @platform/observability logger (WWP-163)
    logger: { debug: console.debug, info: console.info, warn: console.warn, error: console.error },
  });
}
